import './App.css';
import Page from './Page.js';
import React from 'react'




function App() {

  return (
    <>
      <Page>

      </Page>
    </>
  );
}
  

export default App;
